import React from "react"
import { Container, Row, Col } from "reactstrap"
import Heading from "../../../components/shared/heading"
import { PageTitleWrap } from "./page-title-area.stc"

const PageTitleArea = ({ titleCSS, taglineCSS, title, tagline }) => {
  return (
    <PageTitleWrap>
      <Container>
        <Row>
          <Col lg={{ size: 10, offset: 1 }} xl={{ size: 7, offset: 2 }}>
            {title && <Heading {...titleCSS}>{title}</Heading>}
            {tagline && <Heading {...taglineCSS}>{tagline}</Heading>}
          </Col>
        </Row>
      </Container>
    </PageTitleWrap>
  )
}

PageTitleArea.defaultProps = {
  titleCSS: {
    as: "h5",
    fontSize: [1],
    textTransform: "capitalize",
    mb: "17px",
  },
  taglineCSS: {
    color: "secondaryColor",
    fontSize: [4, 5],
    fontWeight: "bold",
    lineHeight: [1.4, 1.375],
  },
}

export default PageTitleArea
